import React, {useEffect, useState} from 'react';
import {ArrowDown, Inbox, Search, X} from 'lucide-react';
import type {Message} from './types';

type Props = {
  messages: Message[];
  opened: Record<string, number>;
  hasStarted: boolean;
  account: string;
  onOpen: (message: Message) => void;
};

// This component only mounts while the player can use the inbox. It does not
// open an email, move focus, or change either game timer on the player's behalf.
export function GoodmailInbox({messages, opened, hasStarted, account, onOpen}: Props) {
  const [query, setQuery] = useState('');
  const [idle, setIdle] = useState(false);
  useEffect(() => {
    if (hasStarted) return;
    const timer = window.setTimeout(() => setIdle(true), 5000);
    return () => window.clearTimeout(timer);
  }, [hasStarted]);

  const visible = messages.filter(message => `${message.name} ${message.subject}`.toLowerCase().includes(query.trim().toLowerCase()));
  const first = visible[0];
  const showHint = idle && !hasStarted && Boolean(first);

  return <section className="goodmail-inbox" aria-label="Email inbox">
    <label className="goodmail-search">
      <Search size={20} aria-hidden="true"/>
      <input type="search" aria-label="Search inbox" placeholder="Search mail" value={query} onChange={event => setQuery(event.target.value)}/>
    </label>
    <div className="goodmail-folder"><h1><Inbox size={19} aria-hidden="true"/>Inbox <span>{messages.length}</span></h1><span className="goodmail-account" title={account}>{account}</span></div>
    <div className="goodmail-hint-slot" role="status" aria-live="polite">
      {showHint && <button className="goodmail-start-hint" onClick={() => onOpen(first)}><ArrowDown size={18} aria-hidden="true"/><span><span className="pointer-copy">Click</span><span className="touch-copy">Tap</span> the first email to start.</span></button>}
    </div>
    <div className="goodmail-list">
      {visible.map((message, index) => <button
        type="button"
        className={`goodmail-email ${opened[message.id] !== undefined ? 'is-read' : ''} ${showHint && index === 0 ? 'is-hinted' : ''}`}
        key={message.id}
        onClick={() => onOpen(message)}
        aria-label={`Open email from ${message.name}: ${message.subject}`}
      >
        <span className="goodmail-sender-icon" aria-hidden="true">{message.initials}</span>
        <span className="goodmail-email-copy">
          <span className="goodmail-email-top"><strong>{message.name}</strong><time>{message.received}</time></span>
          <span className="goodmail-subject">{message.subject}</span>
          <span className="goodmail-preview">{message.preview}</span>
        </span>
      </button>)}
      {!first && <div className="goodmail-empty"><Search size={24} aria-hidden="true"/><h2>No matching emails</h2><p>Try a sender’s name or a word from the subject.</p><button onClick={() => setQuery('')}><X size={16} aria-hidden="true"/>Clear search</button></div>}
    </div>
  </section>;
}
